<ion-button
  fill="clear"
  shape="round"
  (click)="closeModal()"
>
  <ion-icon
    [name]="icon"
    [attr.aria-label]="ariaLabel"
  ></ion-icon>
</ion-button>
